import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
  useLocation
} from "react-router-dom";
import Header from "./features/header/Header";
import Navigation from "./features/navigation/Navigation";
import Dashboard from "./features/dashboard/Dashboard";
import Login from "./features/user/login";
import Books from "./features/books/Books";
import AddBooks from "./features/books/AddBook";
import Categories from "./features/categories/Categories";
import AddCustomer from "./features/customers/AddCustomer";
import Discounts from "./features/discounts/Discounts";
import Operators from "./features/operators/Operators";
import Orders from "./features/orders/Orders";
import Settings from "./features/settings/Settings";
import Transactions from "./features/transactions/Transactions";
import Customers from "./features/customers/Customers";
import { connect } from "react-redux";
import {
  getStore,
  getEvents,
  setActiveEvent,
  getSubscription,
} from "./features/dashboard/actions";
import _ from "lodash";
import AddOperator from "./features/operators/AddOperator";
import AddEvent from "./features/events/AddEvent";

const App = (props) => {
  useEffect(() => {
    props.getStore();
    props.getEvents();
    props.getSubscription();
  }, []);

  useEffect(() => {
    document.title = "سپنتا - پنل مدیریت";
    if (!_.isEmpty(props.events)) {
      const maxKey = _.max(_.keys(props.events));
      const recentEvent = props.events[maxKey];
      props.setActiveEvent(recentEvent.id);
      if (props.location.pathname == "/") {
        props.history.push(`/dashboard/${recentEvent.id}`);
      }
    }
  }, [props.events]);

  const location = useLocation();

  useEffect(() => {
    setShowResponsiveNav(false)
  }, [location]);

  const [showResponsiveNav, setShowResponsiveNav] = useState(false);

  return (
    <div className="App">
      <Header setShowResponsiveNav={setShowResponsiveNav} />
      <Navigation
        showResponsiveNav={showResponsiveNav}
        setShowResponsiveNav={setShowResponsiveNav}
      />
      <div className="mainContent">
        {props.signOut ? (
          <Login />
        ) : (
          <Switch>
            <Route path="/books/:id">
              <AddBooks />
            </Route>
            <Route path="/books">
              <Books />
            </Route>
            <Route path="/categories">
              <Categories />
            </Route>
            <Route path="/customers">
              <Customers />
            </Route>
            <Route path="/addcustomer">
              <AddCustomer />
            </Route>
            <Route path="/operators/:id">
              <AddOperator />
            </Route>
            <Route path="/operators">
              <Operators />
            </Route>
            <Route path="/orders">
              <Orders />
            </Route>
            <Route path="/settings">
              <Settings />
            </Route>
            <Route path="/transactions">
              <Transactions />
            </Route>
            <Route path="/dashboard">
              <Dashboard />
            </Route>
            <Route path="/events/:id">
              <AddEvent />
            </Route>
            <Route path="/login">
              <Login />
            </Route>
          </Switch>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ signOut, events }) => ({
  signOut,
  events,
});

export default connect(mapStateToProps, {
  getStore,
  getEvents,
  setActiveEvent,
  getSubscription,
})(withRouter(App));
